import classNames from 'classnames';
import React, { ReactElement, useContext } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

import { ITabHeaderContext, TabHeaderContext } from './TabHeaderContext';
import { ITabNavigationContext, TabNavigationContext } from './TabNavigationContext';

type ITabNavigationLinkProps = NavLinkProps;

export function OzTabNavigationLink (props: ITabNavigationLinkProps): ReactElement | null {
    const { children, to, ...rest }: ITabNavigationLinkProps = props;
    const tabNavigation: ITabNavigationContext = useContext(TabNavigationContext);
    const tabHeaderContext: ITabHeaderContext = useContext(TabHeaderContext);

    if (!tabNavigation) {
        throw new Error('OzTabNavigationLink must be used within an OzTabNavigation');
    }

    if (!tabHeaderContext) {
        throw new Error('OzTabNavigationLink must be used within an OzTabHeader');
    }

    const isNavLinkActive: boolean = tabNavigation.activeIndex === tabHeaderContext.index;

    const tabNavigationClassNames: string = classNames({
        'border-b-4 pb-1/2 inline-block': true,
        'border-transparent hover:border-navy-200': !isNavLinkActive,
        'border-teal-800': isNavLinkActive,
    });

    return (
        <NavLink
            to={to}
            className={tabNavigationClassNames}
            {...rest}
        >
            {children}
        </NavLink>
    );
}
